/**
 * App Logger — reports uncaught errors and unhandled promise rejections to
 * the shared fs-assistant logging service (see src/api/appLog.js).
 */
import { sendAppLogBatch } from '../api/appLog';
import { generateId } from '../utils/ids';
import { APPLICATION_NAME } from '../config/api';

function report(level, message, details) {
  const entry = {
    id: generateId(),
    timestamp: new Date().toISOString(),
    level,
    message,
    page_path: window.location.pathname,
    environment: process.env.NODE_ENV || 'production',
    details,
    Application: APPLICATION_NAME,
  };

  sendAppLogBatch([entry]).catch((error) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[appLogger] failed to send app log:', error.message);
    }
  });
}

let initialized = false;

export function initAppLogger() {
  if (initialized || typeof window === 'undefined') {
    return;
  }
  initialized = true;

  window.addEventListener('error', (event) => {
    report('ERROR', event.message || 'Uncaught error', {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    report('ERROR', 'Unhandled promise rejection', {
      reason: String(event.reason),
      stack: event.reason?.stack,
    });
  });
}
